import clsx from 'clsx'
import { FormikState, getIn } from 'formik'

export const defaultClassNameCheckBox =
  'w-full py-4 px-2 mr-0 rounded-lg border-solid border border-[#E5E5E7] font-semibold text-sm shadow'

export const defaultClassNameInput = 'rounded-lg px-4 py-2 border-solid border text-sm'

export const defaultClassNameRadioGroup =
  'w-full h-full py-4 px-2 mr-0 rounded-lg border-solid border border-[#E5E5E7] font-semibold text-sm'

export const classNameCheckBox = (selectedValue: string, value: string) => {
  return `${defaultClassNameCheckBox} ${clsx({
    'bg-[#F4F6F0] text-[#3C5337]': selectedValue === value,
    'bg-[#fff] text-[#323539]': selectedValue !== value,
  })}`
}

export const classNameInput = <T>(fieldName: string, state: FormikState<T>) => {
  const error = getIn(state.errors, fieldName)
  const touch = getIn(state.touched, fieldName)

  return `${defaultClassNameInput} ${clsx({
    'border-[#E5E5E7]': !error || !touch,
  })}`
}

export const classNameRadioGroup = (
  selectedValue: string | number | boolean,
  value: string | number | boolean,
) => {
  return `${defaultClassNameRadioGroup} ${clsx({
    'bg-[#F4F6F0] text-[#3C5337]': selectedValue === value,
    'bg-[#fff] text-[#323539]': selectedValue !== value,
  })}`
}
